import { getPath } from '@/router/common'

const baseUrl = {
  title: 'OCR信息设置',
  path: 'baseSetting'
}

export default [
  {
    path: getPath('oCRSetting', baseUrl),
    name: 'BaseSettingOCRSetting',
    component: () =>
      import(
        /* webpackChunkName: "OCRSetting" */ '@/views/baseSetting/oCRSetting/index.vue'
      ),
    meta: {
      title: 'OCR信息设置'
    }
  },
  {
    path: getPath('shippernoSetting', baseUrl),
    name: 'ShippernoSetting',
    component: () =>
      import(
        /* webpackChunkName: "ShippernoSetting" */ '@/views/baseSetting/shippernoSetting/index.vue'
      ),
    meta: {
      title: '厂家单号设置'
    }
  },
  {
    path: getPath('dailibsiteSetting', baseUrl),
    name: 'DailibsiteSetting',
    component: () =>
      import(
        /* webpackChunkName: "DailibsiteSetting" */ '@/views/baseSetting/dailibsiteSetting/index.vue'
      ),
    meta: {
      title: '实际发站设置'
    }
  },
  {
    path: getPath('VolumgesetupSetting', baseUrl),
    name: 'VolumgesetupSetting',
    component: () =>
      import(
        /* webpackChunkName: "VolumgesetupSetting" */ '@/views/baseSetting/VolumgesetupSetting/index.vue'
      ),
    meta: {
      title: '体积规格设置'
    }
  },
  {
    path: getPath('WeightgesetupSetting', baseUrl),
    name: 'WeightgesetupSetting',
    component: () =>
      import(
        /* webpackChunkName: "WeightgesetupSetting" */ '@/views/baseSetting/WeightgesetupSetting/index.vue'
      ),
    meta: {
      title: '重量规格设置'
    }
  },
  {
    path: getPath('QuickFindSealSetting', baseUrl),
    name: 'QuickFindSealSetting',
    component: () =>
      import(
        /* webpackChunkName: "QuickFindSealSetting" */ '@/views/baseSetting/QuickFindSealSetting/index.vue'
      ),
    meta: {
      title: '印章设置'
    }
  },
  {
    path: getPath('ExpressCompanySetting', baseUrl),
    name: 'ExpressCompanySetting',
    component: () =>
      import(
        /* webpackChunkName: "ExpressCompanySetting" */ '@/views/baseSetting/ExpressCompanySetting/index.vue'
      ),
    meta: {
      title: '快递公司设置'
    }
  },
  {
    path: getPath('RemarksSetting', baseUrl),
    name: 'RemarksSetting',
    component: () =>
      import(
        /* webpackChunkName: "RemarksSetting" */ '@/views/baseSetting/RemarksSetting/index.vue'
      ),
    meta: {
      title: '备注设置'
    }
  },
  {
    path: getPath('ProductcodeSetting', baseUrl),
    name: 'ProductcodeSetting',
    component: () =>
      import(
        /* webpackChunkName: "RemarksSetting" */ '@/views/baseSetting/productcodeSetting/index.vue'
      ),
    meta: {
      title: '产品代码设置'
    }
  },
  {
    path: getPath('ImportVolumgesetupExcel', baseUrl),
    name: 'ImportVolumgesetupExcel',
    component: () =>
      import(
        /* webpackChunkName: "ImportVolumgesetupExcel" */ '@/views/baseSetting/importVolumgesetupExcel/index.vue'
      ),
    meta: {
      title: '体积规格导入'
    }
  },
  {
    path: getPath('VolumgesetupDetails', baseUrl),
    name: 'VolumgesetupDetails',
    component: () =>
      import(
        /* webpackChunkName: "VolumgesetupDetails" */ '@/views/baseSetting/volumgesetupDetails/index.vue'
      ),
    meta: {
      title: '体积规格导入详情'
    }
  },
  {
    path: getPath('VolumgesetupIndex', baseUrl),
    name: 'VolumgesetupIndex',
    component: () =>
      import(
        /* webpackChunkName: "VolumgesetupIndex" */ '@/views/baseSetting/volumgesetupIndex/index.vue'
      ),
    meta: {
      title: '导入体积规格'
    }
  },
  {
    path: getPath('ImportWeightgesetupExcel', baseUrl),
    name: 'ImportWeightgesetupExcel',
    component: () =>
      import(
        /* webpackChunkName: "ImportWeightgesetupExcel" */ '@/views/baseSetting/importWeightgesetupExcel/index.vue'
      ),
    meta: {
      title: '重量规格导入'
    }
  },
  {
    path: getPath('WeightgesetupIndex', baseUrl),
    name: 'WeightgesetupIndex',
    component: () =>
      import(
        /* webpackChunkName: "WeightgesetupIndex" */ '@/views/baseSetting/weightgesetupIndex/index.vue'
      ),
    meta: {
      title: '导入重量规格'
    }
  },
  {
    path: getPath('WeightgesetupDetails', baseUrl),
    name: 'WeightgesetupDetails',
    component: () =>
      import(
        /* webpackChunkName: "WeightgesetupDetails" */ '@/views/baseSetting/weightgesetupDetails/index.vue'
      ),
    meta: {
      title: '导入重量详情'
    }
  },
  {
    path: getPath('PackPageSetting', baseUrl),
    name: 'baseSettingPackPageSetting',
    component: () =>
      import(
        /* webpackChunkName: "baseSettingPackPageSetting" */ '@/views/baseSetting/packPageSetting/index.vue'
      ),
    meta: {
      title: '包装设置'
    }
  },
  {
    path: getPath('BoardingfeeSetting', baseUrl),
    name: 'baseSettingBoardingfeeSetting',
    component: () =>
      import(
        /* webpackChunkName: "baseSettingBoardingfeeSetting" */ '@/views/baseSetting/boardingfeeSetting/index.vue'
      ),
    meta: {
      title: '上车费单价设置'
    }
  },
  {
    path: getPath('PackageAcctran', baseUrl),
    name: 'baseSettingPackageAcctran',
    component: () =>
      import(
        /* webpackChunkName: "baseSettingPackageAcctran" */ '@/views/baseSetting/packageAcctran/index.vue'
      ),
    meta: {
      title: '包装运费设置'
    }
  },
  {
    path: getPath('whSetting', baseUrl),
    name: 'baseSettingwhSetting',
    component: () =>
      import(
        /* webpackChunkName: "baseSettingwhSetting" */ '@/views/baseSetting/whSetting/index.vue'
      ),
    meta: {
      title: '货物品名'
    }
  },
  {
    path: getPath('OrderSiteMapping', baseUrl),
    name: 'OrderSiteMapping',
    component: () =>
      import(
        /* webpackChunkName: "baseSettingOrderSiteMapping" */ '@/views/baseSetting/OrderSiteMapping/index.vue'
      ),
    meta: {
      title: '订单网点映射表'
    }
  },
  {
    path: getPath('ImportwhSettingExcel', baseUrl),
    name: 'baseSettingImportwhSettingExcel',
    component: () =>
      import(
        /* webpackChunkName: "baseSettingImportwhSettingExcel" */ '@/views/baseSetting/importwhSettingExcel/index.vue'
      ),
    meta: {
      title: '货物品名导入记录'
    }
  },
  {
    path: getPath('whSettingIndex', baseUrl),
    name: 'baseSettingwhSettingIndex',
    component: () =>
      import(
        /* webpackChunkName: "baseSettingwhSettingIndex" */ '@/views/baseSetting/whSettingIndex/index.vue'
      ),
    meta: {
      title: '货物品名导入'
    }
  },
  {
    path: getPath('whSettingDetails', baseUrl),
    name: 'baseSettingwhSettingDetails',
    component: () => import(/* webpackChunkName: "baseSettingwhSettingDetails" */ '@/views/baseSetting/whSettingDetails/index.vue'),
    meta: {
      title: '货物导入查看明细'
    }
  },
  {
    path: getPath('SpecificationsTemplate', baseUrl),
    name: 'baseSetting_SpecificationsTemplate',
    component: () => import(/* webpackChunkName: "baseSetting_SpecificationsTemplate" */ '@/views/baseSetting/specificationsTemplate/index.vue'),
    meta: {
      title: '规格导入模板管理'
    }
  },
  {
    path: getPath('SpecificationsTemplateEdit', baseUrl),
    name: 'baseSetting_SpecificationsTemplateEdit',
    component: () => import(/* webpackChunkName: "baseSetting_SpecificationsTemplateEdit" */ '@/views/baseSetting/specificationsTemplateEdit/index.vue'),
    meta: {
      title: '新增规格导入模板'
    }
  }
]
